import { Box, Card, Heading, Paragraph, Switch } from '@zillow/constellation-10';
import { Controller } from 'react-hook-form';
import { useApplicationContextOrUndefined } from '../../../../contexts/ApplicationContext';

export function useListingOwnerDisplayName() {
  return useApplicationContextOrUndefined()?.listing.listingOwner?.name?.trim() || 'the landlord';
}

export function ContactPermissionCard({
  name,
  title,
  description,
}: {
  name: 'canContactEmployer' | 'canContactLandlords';
  title: string;
  description: string;
}) {
  return (
    <Card elevated={false} outlined>
      <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 'default' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', gap: 'tightest' }}>
          <Heading level={4} css={{ textStyle: 'body-bold' }}>
            {title}
          </Heading>
          <Paragraph>{description}</Paragraph>
        </Box>
        <Controller
          name={name}
          render={({ field: { value, onChange } }) => (
            <Switch aria-label={title} checked={value === true} onChange={() => onChange(value !== true)} />
          )}
        />
      </Box>
    </Card>
  );
}
